import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MailService } from 'src/app/core/services/mail.service';
import { ToastPosition, ToastService } from 'src/app/core/services/toast.service';
import { OrderPreviewData } from '../../order-preview.component';
// import { Keyboard } from '@awesome-cordova-plugins/keyboard/ngx';

@Component({
  selector: 'app-mail',
  templateUrl: './mail.component.html',
  styleUrls: ['./mail.component.scss'],
})
export class MailComponent implements OnInit {
  @Input({ required: true }) data!: OrderPreviewData;
  mailForm: FormGroup = this.formBuilder.group({
    email: ['', [Validators.required, Validators.email]]
  });

  isSubmitted = false;
  emailAddress!: string;

  constructor(
    private mailService: MailService,
    public formBuilder: FormBuilder,
    private toastService: ToastService,
    // private keyboard: Keyboard,
  ) { }

  ngOnInit(): void {
    this.emailAddress = this.data.order.client.email;
  }

  get errorControl() {
    return this.mailForm.controls;
  }

  sendEmail() {
    if (!this.mailForm.valid) {
      this.toastService.showErrorToast("U gaf een onjuiste email in.", ToastPosition.Top);
    }
    else {
      // if (this.keyboard.isVisible) {
      //   this.keyboard.hide();
      // }
      this.isSubmitted = true;
      this.mailService.sendEmail(this.data.order.id, this.mailForm.get("email")!.value).subscribe(() =>
        this.toastService.showSuccessToast("Email verstuurd", ToastPosition.Top)
      );
    }
  }
}
